import script from "./LogoMain.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoMain.vue?vue&type=script&setup=true&lang=js"

import "./LogoMain.vue?vue&type=style&index=0&id=10f77421&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f77421"]])

export default __exports__